class concepts {
  constructor(
    cat,
    conceptId,
    denyAccess,
    hoursWorked,
    licTot,
    name,
    roundoutLiq,
    ws
  ) {
    (this.cat = cat),
      (this.conceptId = conceptId),
      (this.denyAccess = denyAccess),
      (this.hoursWorked = hoursWorked),
      (this.licTot = licTot),
      (this.name = name),
      (this.roundoutLiq = roundoutLiq),
      (this.ws = ws);
  }
  static fromJson({
    cat,
    conceptoId,
    denegarAcceso,
    horTrab,
    licTot,
    nombre,
    redondeaLiq,
    ws,
  }) {
    return new concepts(
      cat,
      conceptoId,
      denegarAcceso,
      horTrab,
      licTot,
      nombre,
      redondeaLiq,
      ws
    );
  }
}
export default concepts;
